import React, { useState } from 'react';
import { getCookie, logAction } from "./log.js";
import "../css/PopUpDeleteObject.css";

const PopUpDeleteObject = ({ object, onClose, navigateToPath, currentPath }) => {
    /**
     * loading : état local pour gérer l'affichage d'un indicateur
     * pendant la suppression asynchrone.
     */
    const [loading, setLoading] = useState(false);

    /**
     * API_URL : URL de base de l'API provenant des variables
     * d'environnement pour effectuer la requête de suppression.
     */
    const API_URL = process.env.REACT_APP_API_URL;

    /**
     * handleDownload : fonction déclenchée au clic sur "Supprimer",
     * effectue une requête POST vers l'API pour supprimer l'objet.
     * - Log l'action si succès.
     * - Gère les erreurs via alert et console.
     * - Recharge la vue du dossier courant via navigateToPath.
     */
    const handleDownload = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${API_URL}/api/deleteObject.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({
                    dossier: object.id,
                    path: object.path,
                    type: object.type,
                }),
            });

            if (response.ok) {
                logAction({
                    action: "deleteFile",
                    dossierId: object.id,
                    utilisateurId: getCookie("userId"),
                    fichier: object.name,
                    path: object.path,
                });
            } else {
                const err = await response.json();
                alert(err.error || "Erreur lors de la suppression.");
            }
        } catch (error) {
            console.error("Erreur lors de la suppression :", error);
            alert("Erreur lors de la suppression.");
        } finally {
            setLoading(false);
            onClose();
            await navigateToPath(currentPath); // Recharge le dossier affiché actuellement
        }
    };

    return (
        <div className="popupDelete-overlay">
            <div className="popupDelete-content">
                Voulez vous supprimer le fichier : <h3>{object.name}</h3>
                <div className="flex justify-end -popupDelete-actions">
                    <button className='btn btn-error mr-2' onClick={handleDownload} disabled={loading}>
                        {loading ? "Chargement..." : "Supprimer"}
                    </button>
                    <button className='btn' onClick={onClose}>Fermer</button>
                </div>
            </div>
        </div>
    );
};

export default PopUpDeleteObject;
